// extracted by mini-css-extract-plugin
export default {"main_container":"style_main_container__mkLu7","header":"style_header__8HkKY","tv_show_detail":"style_tv_show_detail__W8DRy","recommendations":"style_recommendations__ZXxsl"};